import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7909b8d2")

_pushScopeId("data-v-7909b8d2")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "panel"
}
const _hoisted_3 = {
  key: 0,
  class: "spinner-wrapper"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "archived-dialog-title has-text-danger" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa-2x fas fa-archive pr-3" }),
  /*#__PURE__*/_createVNode("span", null, "File was archived")
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", null, "File has been already archived and is not accessible from the application.", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createTextVNode("If the file needs to be restored, please open a ticket via Service Desk "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" and provide the registration number and name of the file.")
], -1)
const _hoisted_7 = { class: "buttons" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_loading = _resolveComponent("loading")
  const _component_modal_card = _resolveComponent("modal-card")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (!_ctx.documents?.length)
      ? (_openBlock(), _createBlock("span", _hoisted_1, "No documents available"))
      : (_openBlock(), _createBlock("div", _hoisted_2, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.documents, (doc, index) => {
            return (_openBlock(), _createBlock("div", {
              key: index,
              class: "link-wrapper"
            }, [
              _createVNode("a", {
                class: "panel-block",
                onClick: ($event: any) => (_ctx.downloadFile(doc)),
                target: "_blank"
              }, [
                _createVNode("span", {
                  class: "panel-icon",
                  title: _ctx.areFilesArchived ? 'File was archived' : ''
                }, [
                  _createVNode("i", {
                    class: _ctx.getFileIcon(doc),
                    "aria-hidden": "true"
                  }, null, 2)
                ], 8, ["title"]),
                _createVNode("span", {
                  title: doc.documentName
                }, _toDisplayString(doc.documentName), 9, ["title"])
              ], 8, ["onClick"]),
              (_ctx.isLoading[doc.referenceName])
                ? (_openBlock(), _createBlock("div", _hoisted_3, [
                    _createVNode(_component_loading)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])),
    _createVNode(_component_modal_card, { active: _ctx.isArchivedDialogVisible }, {
      title: _withId(() => [
        _hoisted_4
      ]),
      body: _withId(() => [
        _hoisted_5,
        _hoisted_6
      ]),
      foot: _withId(() => [
        _createVNode("div", _hoisted_7, [
          _createVNode("button", {
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isArchivedDialogVisible = false))
          }, "OK")
        ])
      ]),
      _: 1
    }, 8, ["active"])
  ], 64))
})